// extracted by mini-css-extract-plugin
module.exports = {"cls1":"page-2-Article-module--cls1--1PYbZ","cls2":"page-2-Article-module--cls2--17t9o page-2-Article-module--cls1--1PYbZ"};